<template>
  <v-container class="d-flex flex-column align-center" style="height: 100vh;">
    <img
      src="MediaAnalytic.png"
      width="600"
      alt="Crawling Manager"
      class="module-image"
    />

    <v-row>
      <v-col cols="12" class="text-center">
        <h1 class="combined-text">
          <span class="crawling-text">Crawling</span> <span class="manager-text">Manager</span>
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CrawlingManagerComponent',

  mounted() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  },
};
</script>

<style scoped>
.module-image {
  margin-top: -60px;
}

.combined-text {
  font-size: 48px;
  font-weight: bold;
}

.crawling-text {
  color: #007bff;
}

.manager-text {
  color: #000000;
}
</style>
